import { Component, ElementRef, Input, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { NgxSpinnerService } from "ngx-spinner";
import { ApiService } from "src/app/core/helpers/apiClient";
import appSettings from "../../../../assets/settings/system.settings.json"
import Swal from 'sweetalert2';
import { DatePipe } from "@angular/common";
import { AuthGuard } from "src/app/core/guards/auth.guard";

@Component({
  selector: 'landingpages-landingpage',
  styleUrls: ['./landingpage.component.scss'],
  templateUrl: './landingpage.component.html',
  providers: [DatePipe]
})
export class  LandingPageComponent implements OnInit {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authGuard: AuthGuard,
  ) {
  }

  ngOnInit(): void {
    };

    estateDashboard(e) {
      this.router.navigate(['../', { guid: e }], { relativeTo: this.route });
    }

    millDasboard(e) {
      this.router.navigate(['/cropdailyestate/details', { guid: e }], { relativeTo: this.route });
    }

    checkAccess(controller) {
      if (controller === "view") {
        return this.authGuard.hasClaimsAuthGuard([
          { project: appSettings.RolesAccess.Project.Boustead_PAD, module: appSettings.RolesAccess.Module.EstateDashboard, action: appSettings.RolesAccess.Action.View }
        ]);
      }
    }

    checkAccessMill(controller) {
      if (controller === "view") {
        return this.authGuard.hasClaimsAuthGuard([
          { project: appSettings.RolesAccess.Project.Boustead_PAD, module: appSettings.RolesAccess.Module.MillDashboard, action: appSettings.RolesAccess.Action.View }
        ]);
      }
    }

  }
  
  
